import defaultStore from '@/store';
import globalContentVariables from '@/lang/global-content-variables';
import {
  phoneRegex,
  phoneReplacePattern
} from '@/constants';

let store = null;

export function setStore (newStore) {
  store = newStore;
}

export function varReplace (str, map) {
  if (!store) store = defaultStore;

  const regex = /%([a-zA-Z][^\s]*?)%/g;
  let matches;
  let newString = str;

  let compiledMap = Object.assign({}, map, globalContentVariables);

  while ((matches = regex.exec(str)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (matches.index === regex.lastIndex) {
      regex.lastIndex++;
    }

    matches.forEach(() => {
      let innerMatch = matches[1];
      let mapValue = String(compiledMap[innerMatch]);

      if (mapValue.indexOf('getter:') >= 0) {
        let getter = mapValue.replace('getter:', '');
        if (store.getters[getter]) {
          newString = newString.replace(matches[0], store.getters[getter]);
        }
      } else if (mapValue.indexOf('getter(phone):') >= 0) {
        let getter = mapValue.replace('getter(phone):', '');
        if (store.getters[getter]) {
          newString = newString.replace(matches[0], store.getters[getter].replace(phoneRegex, phoneReplacePattern));
        }
      } else {
        newString = newString.replace(matches[0], mapValue);
      }

    });
  }

  return newString;
}